import React from 'react'
import { logoutWebUser } from '../../Auth/AuthActions'
import store from '../../store'

export default ({history}) => {
  React.useEffect(() => {
    history.replace('/')
    store.dispatch(logoutWebUser(true))
  }, [])
  return null;
}



// WEBPACK FOOTER //
// ./src/components/Epass/EpassLogout.js